/*
  In order to ensure question continuity between databases (dev, prod
  qa, etc.) is to tie each questions to one specific GUID. This ensures
  question data (answers and pictures) are tied to the exact question
  across databases.
*/

const useQuestions = () => {
  /* 
    Object mapping readable keys to the database table question GUIDs
    from DWH1 COLLECTOR_AUDIT_QUESTIONS.
  */
  const questions = {
    damagePrevention: "DC031A1E5495C281E05340FE18AC1097",
    equipmentWorkPractices: "DC031A1E5493C281E05340FE18AC1097",
    jobSafetyAnalysis: "DC030F42AA7F94E4E05341FE18ACD742",
    locateTickets: "DC02FE59607C5907E05340FE18AC55FF",
    qualityOfWork: "DC031A1E5494C281E05340FE18AC1097",
    rubberMats: "DC031A1E5492C281E05340FE18AC1097",
    vehiclesParked: "DC030F42AA8094E4E05341FE18ACD742",
    ppe: "E3A0B0D229FF6590E05341FE18AC946A",
  };

  const splicerQuestions = {
    fiberSplicing: "E34C46E4E14CCD09E05340FE18ACEFA6",
    housekeeping: "E34C46E4E14DCD09E05340FE18ACEFA6",
    requiredPPE: "E34C3F3486AF8B06E05341FE18ACB0A8",
    requiredWAP: "E34C3F3486B08B06E05341FE18ACB0A8",
  };

  const splicerToolHeaders = {
    fiberIdentifier: "Fiber Identifier",
    fusionSplice: "Fusion Splice",
    ladders: "Ladders",
    metronetSupply: "Metronet Supply",
    misc: "Misc",
    opticalLoss: "Optical Loss",
    otdr: "OTDR",
    splicerInfo: "Splicer Information",
  };

  const splicerToolQuestions = {
    bareFiberAdapterMakeModel: "Bare Fiber Adapter Make/Model",
    bufferTubeMakeModel: "Buffer Tube Access Tool Make/Model",
    conesMakeModel: "Cones Safety 5 Each Make/Model",
    coreTubeEntryKitMakeModel: "Core Tube Entry Kit Make/Model",
    drill: "Drill Make/Model",
    exfoLaunchBagMakeModel: "EXFO Launch Bag Make/Model",
    fiberMakeModel: "Fiber Identifier Make/Model",
    fiberSerial: "Fiber Identifier Serial #",
    fishTapeMakeModel: "Fish Tape Make/Model",
    foDropSlitterMakeModel: "Fiber-Optic Drop Slitter Make/Model",
    fsMachineRibbonMakeModel: "Fusion Splice Machine (Ribbon) Make/Model",
    fsMachineRibbonSerial: "Fusion Splice Machine (Ribbon) Serial #",
    fsMachineSingleMakeModel: "Fusion Splice Machine (Single) Make/Model",
    fsMachineSingleSerial: "Fusion Splice Machine (Single) Serial #",
    handToolsMakeModel: "Hand Tools Make/Model",
    harnessMakeModel:
      "Harness with Belt and Pads 3-D Lanyard Rope 3in or 6ft Positioning Strap Make/Model",
    ladder28ftMakeModel: "Ladder 28ft Make/Model",
    ladder6ftMakeModel: "Ladder 6ft Step Make/Model",
    midspanSplitterMakeModel: "Mid-span Splitter Tool Make/Model",
    opticalLossMakeModel1: "Optical Loss Test Kit Make/Model 1",
    opticalLossMakeModel2: "Optical Loss Test Kit Make/Model 2",
    opticalLossSerial1: "Optical Loss Test Kit Serial # 1",
    opticalLossSerial2: "Optical Loss Test Kit Serial # 2",
    otdrMakeModel: "OTDR Make/Model",
    otdrSerial: "OTDR Serial #",
    safetyVestAndHardHatMakeModel: "Safety Vest and Hard Hat Make/Model",
    signAndHolderMakeModel: "Sign and Holder 2 Each Make/Model",
    splicerTentMakeModel: "Splicer Tent 6ft Make/Model",
    splicingTableMakeModel: "Splicing table Make/Model",
    toolNotes: "Other Tools/Notes",
    toolsetMakeModel: "Tool Set Make/Model",
    trailerTypeAndNum: "Trailer Type and #",
    vehicleNumber: "Vehicle #",
    vehicleType: "Vehicle Type",
  };

  return {
    questions,
    splicerQuestions,
    splicerToolHeaders,
    splicerToolQuestions,
  };
};

export default useQuestions;
